/**
 * @file routes/_app/non-conformities/index.tsx
 * @description 不符合項管理根路徑重定向。
 *
 * 訪問 /non-conformities 時自動跳轉到 /non-conformities/list（菜單實際入口）。
 * 避免無 /list 後綴時 404。
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/non-conformities/')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/non-conformities/list' });
  },
});
